
import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardFooter, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { FileText, ArrowRight } from "lucide-react";

export const technicalDocs = [
  {
    title: "Portfolio Overview & Tax Efficiency",
    description: "Detailed guide to monitoring portfolio health with a focus on tax optimization.",
    version: "v1.0",
    lastUpdated: "May 8, 2025",
    category: "Platform Features",
    slug: "portfolio-tax-overview"
  },
  {
    title: "Trading Algorithms Whitepaper",
    description: "Comprehensive overview of our AI/ML architecture",
    version: "v2.1",
    lastUpdated: "March 2025",
    category: "Architecture",
    slug: "trading-algorithms"
  },
  {
    title: "Strategy Optimization Guide",
    description: "Best practices for fine-tuning trading strategies",
    version: "v1.3",
    lastUpdated: "February 2025",
    category: "Guides",
    slug: "strategy-optimization"
  }
];

export const DocsTechDocsSection = () => (
  <div className="space-y-6">
    {technicalDocs.map((doc, index) => (
      <Card key={index} className="bg-gray-800/40 border-gray-700/50 overflow-hidden hover:bg-gray-800/70 transition-colors">
        <div className="p-6">
          <div className="flex justify-between items-start">
            <div>
              <div className="flex items-center space-x-2 mb-2">
                <Badge className="bg-indigo-600/20 text-indigo-400">{doc.category}</Badge>
                <Badge variant="outline" className="text-gray-400">{doc.version}</Badge>
              </div>
              <h3 className="text-xl font-semibold text-white mb-2">{doc.title}</h3>
              <p className="text-gray-300 mb-3">{doc.description}</p>
              <p className="text-sm text-gray-400">Last updated: {doc.lastUpdated}</p>
            </div>
            <Button size="sm" className="bg-blue-600 hover:bg-blue-700" onClick={() => window.location.href = `/docs/${doc.slug}`}>View Docs</Button>
          </div>
        </div>
      </Card>
    ))}
    <div className="pt-4 flex justify-center">
      <Button variant="outline" className="border-gray-700 text-gray-300 hover:text-white">
        View All Technical Docs
        <ArrowRight className="ml-2 h-4 w-4" />
      </Button>
    </div>
  </div>
);
